import { Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { isValid } from 'date-fns/fp';
import { Control, Controller } from 'react-hook-form';

import { IntakeRequestLineItem } from '../../IntakeRequestLineItemStep.schema';

type DateRangePickerProps = {
  control: Control<IntakeRequestLineItem>;
  disabled?: boolean;
  nameEarly: keyof IntakeRequestLineItem;
  nameLate: keyof IntakeRequestLineItem;
  labelEarly: string;
  labelLate: string;
};

export const DateRangePicker = ({
  control,
  disabled,
  nameEarly,
  nameLate,
  labelEarly,
  labelLate,
}: DateRangePickerProps) => (
  <Stack
    direction="row"
    spacing={3}
    sx={{
      alignItems: 'flex-start',
      mt: '15px',
    }}
  >
    <Controller
      control={control}
      name={nameEarly}
      render={({ field, fieldState }) => (
        <DatePicker
          {...field}
          disabled={disabled}
          disablePast
          slotProps={{
            actionBar: { actions: ['today', 'clear'] },
            openPickerButton: { tabIndex: -1 },
            textField: {
              ...field,
              error: !!fieldState.error,
              fullWidth: true,
              InputLabelProps: { shrink: true },
              variant: 'outlined',
              label: labelEarly,
              onBlur: field.onBlur,
              onChange: (date: any) => {
                if (!isValid(date) && date !== null) return;
                field.onChange(date);
              },
            },
          }}
        />
      )}
    />
    <Typography
      sx={{
        alignSelf: 'center',
      }}
    >
      —
    </Typography>
    <Controller
      control={control}
      name={nameLate}
      render={({ field, fieldState }) => (
        <DatePicker
          {...field}
          disabled={disabled}
          disablePast
          slotProps={{
            actionBar: { actions: ['today', 'clear'] },
            openPickerButton: { tabIndex: -1 },
            textField: {
              ...field,
              error: !!fieldState.error,
              fullWidth: true,
              InputLabelProps: { shrink: true },
              variant: 'outlined',
              label: labelLate,
              required: true,
              onBlur: field.onBlur,
              onChange: (date: any) => {
                if (!isValid(date) && date !== null) return;
                field.onChange(date);
              },
            },
          }}
        />
      )}
    />
  </Stack>
);
